var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar',{attrs:{"title":"matcher"}}),_c('Landing',{attrs:{"title":"find matches for your projects, instantly.","subTitle":"The best fits, automatically. Just a few clicks away."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }